




































































































import { Component, Vue } from 'vue-property-decorator';
import { Machine } from "@/models/machine";
import { namespace } from "vuex-class";
import { Maintenance } from "@/models/maintenance";
import MaintenanceRepository from "@/api/MaintenanceRepository";
import { RepositoryFactory } from "@/api/RepositoryFactory";
import MaintenanceListFormRepository from '@/api/MaintenanceListFormRepository';
import { MaintenanceElementCategory } from '@/models/maintenanceListElementEntry';
import { needsMaintenanceListNormalization } from '@/utils/maintenanceListUtils';
import { Customer } from '@/models/customer';
import { Station } from '@/models/station';

const maintenanceRepository: MaintenanceRepository = RepositoryFactory.get('maintenance');
const maintenanceListFormRepository: MaintenanceListFormRepository = RepositoryFactory.get('maintenanceListForm');

const MachineStore = namespace('machine');
const MaintenanceStore = namespace('maintenance');
const CustomerStore = namespace('customer');
const StationStore = namespace('station');
const SettingsStore = namespace('settings');


@Component({
  components: {
    EditMachineComponent: () => import('../components/EditMachine.component.vue'),
    EditMaintenanceList: () => import('../components/EditMaintenanceList.component.vue'),
    MachineMaintenanceTableRowComponent: () => import('../components/MachineMaintenanceTableRow.component.vue'),
    MachineHeader: () => import('../components/machine/MachineHeader.component.vue'),
    ConfirmChecklistExportDialog: () => import('../components/dialog/ConfirmExportDialog.component.vue'),

    ChecklistPreviewComponent: () => import('./Checklist.preview.vue'),

  }
})

export default class MachineDetailsView extends Vue {

  @MachineStore.Action('loadMachine')
  public loadMachine!: (payload: { id: string }) => Promise<Machine>;

  @MaintenanceStore.Action('deleteMaintenance')
  public deleteMaintenance!: (payload: { id: string }) => Promise<Maintenance>;

  @MaintenanceStore.Action("updateMaintenance")
  public updateMaintenance!: (payload: { maintenance: Maintenance }) => Promise<Maintenance>

  @CustomerStore.Action('loadCustomer')
  public loadCustomer!: (payload: { id: string }) => Promise<Customer>;

  @StationStore.Action('loadStation')
  public loadStation!: (payload: { id: string }) => Promise<Station>;

  @SettingsStore.Mutation('setBreadcrumbContext')
  public setBreadcrumbContext!: (context: { customerName?: string; stationName?: string; machineName?: string }) => void;

  public currentMachine: Machine | null = null;
  public selectedMaintenance: Maintenance | undefined;

  public selectedCheckboxes: any[] = [];

  public searchText: string = '';
  public itemsPerPage = 50;

  public exportChecklistExportDialog = false;

  public headers: any[] = [{
    text: 'Produktions-Nummer',
    value: 'productionNr'
  }, {
    text: 'Flap-Nummer',
    value: 'flapNr'
  }, {
    text: 'Wartungsdatum',
    value: 'maintenanceDate'
  }, {
    text: 'Kommentar',
    value: 'comment'
  }, {
    text: 'Wartungsbilder',
    value: 'images',
    align: 'center'
  },

  {
    text: 'Dokumente',
    value: 'documentPdfs',
    align: 'center'
  },

  {
    text: 'Optionen',
    value: 'actions',
    align: 'right'
  }];

  public maintenanceListDialog: boolean = false;
  public dialogDelete: boolean = false;
  public showEditMaintenanceDialog: boolean = false;
  public snackbar: boolean = false;
  public snackbarText: string = '';
  public newForms: any[] = [];
  public loading: boolean = true;
  
  
  public formTypes = [
    { text: 'Zustand der Anlage', value: 'condition' },
    { text: 'Funktion der Anlage', value: 'function' }
  ];


  public async openEditMachineDialog(maintenance: Maintenance) {
    if (maintenance) {
      this.selectedMaintenance = maintenance;
    }
    this.showEditMaintenanceDialog = true;
  }

  public async closeEditMaintenanceDialog(edited: { saved: boolean }) {
    if (edited.saved) {
      try {
        await this.updateMaintenance({ maintenance: this.selectedMaintenance! })
      } catch (e) {

      }
      this.snackbar = true;
      this.snackbarText = `Wartung erfolgreich gespeichert/erstellt.`;
    }
    this.showEditMaintenanceDialog = false;
  }

  public async mounted() {

    try {
      this.loading = true;

      const machineId = this.$route.params.machineId;
      this.currentMachine = await this.loadMachine({ id: machineId });

      const customer = await this.loadCustomer({ id: this.$route.params.customerId });
      const station = await this.loadStation({ id: this.$route.params.stationId });
      this.setBreadcrumbContext({
        customerName: customer.name,
        stationName: station.name,
        machineName: this.currentMachine.tagNo || this.currentMachine.actuatorUnit || 'Antrieb',
      });

      await this.getFormOfActuatorType();
      await this.loadMaintenances();
    } catch (error) {
      console.error('Error loading machine:', error);
    } finally {
      this.loading = false;
    }
  }

  /**
   * Lädt die Maintenances der aktuellen Maschine neu und setzt sie (neueste zuerst).
   */
  public async loadMaintenances() {
    if (!this.currentMachine?.id) return;
    const myMaintenance = await maintenanceRepository.getMaintenancesByMachine(this.currentMachine.id);
    this.currentMachine.maintenances = myMaintenance.data;
    this.currentMachine.maintenances.reverse();
  }

  /**
   * Gets the forms (condition and function) for the current machine's actuator type
   */
  public async getFormOfActuatorType() {
    const actuatorName = this.currentMachine?.actuator?.toLowerCase() || '';
    const res = await maintenanceListFormRepository.getFormsByActuatorName(actuatorName);

    if (res.ok) {
      this.newForms = res.data ?? [];
      return;
    }

    // kontrollierte Fehlerpfade
    if (res.status === 404) {
      // Endpunkt oder Datensätze nicht vorhanden -> still fallback
      console.warn(`[MaintenanceForms] Keine Forms für "${actuatorName}" (404)`);
      this.newForms = [];
      return;
    }

    console.error(`[MaintenanceForms] Fehler ${res.status}: ${res.message}`);
    this.newForms = [];

  }

  public openChecklistExportDialog(item: Maintenance) {
    this.selectedMaintenance = item;
    this.exportChecklistExportDialog = true;
  }

  public async closeChecklistExportDialog(arg: any) {
    if (arg.withImages !== undefined) {
      await this.exportPDF(this.selectedMaintenance!, arg);
    }
    this.selectedMaintenance = undefined;
    this.exportChecklistExportDialog = false;
  }

  public goBackClicked() {
    this.$router.back();
  }

  public deleteItem(item: Maintenance) {
    this.selectedMaintenance = item;
    this.dialogDelete = true
  }

  public async exportPDF(item: Maintenance, options: any) {
    try {
      const maintenanceId = item.id || (item as any)._id;
      if (!maintenanceId) {
        throw new Error('Maintenance ID fehlt');
      }

      if (needsMaintenanceListNormalization(item.maintenanceList)) {
        await maintenanceRepository.updateMaintenance({ ...item, id: maintenanceId } as Maintenance);
      }

      const response = await maintenanceRepository.generatePDF(maintenanceId, options);

      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);

      window.open(url, '_blank');
    } catch (err) {
      this.$notify({
        group: 'fahlke',
        title: 'Fehler',
        text: 'Fehler beim Öffnen der PDF-Datei',
        type: 'error'
      });
    }
  }

  public async deleteItemConfirm() {
    if (this.selectedMaintenance) {
      await this.deleteMaintenance({ id: this.selectedMaintenance.id });
    }
    this.closeDelete();
  }

  public closeDelete() {
    this.selectedMaintenance = undefined;
    this.dialogDelete = false
  }

  /**
   * Returns the filtered forms for the current machine.
   * Filters out forms that have no entries.
   * { maintenanceListElement: { name: "" } },        // wird gefiltert
   */
  get filteredForms() {
    return (this.newForms ?? []).map(form => ({
      ...form,
      filteredEntries: (form.maintenanceListElementEntries ?? []).filter(
        (e: { maintenanceListElement: { name: string; }; }) => e?.maintenanceListElement?.name?.trim()
      )
    }));
  }

  get hasBothForms(): boolean {
    const formTypes = this.filteredForms.map((f: any) => f.formType);
    return formTypes.includes('condition') && formTypes.includes('function');
  }

  /**
   * Creates the NEW Maintenance instance for a machine
   * @returns The created maintenance instance
   */
  // public async createNewChecklistInstance() {
  //   if (!this.currentMachine?.id || !this.hasBothForms) {
  //     if (!this.currentMachine?.id || !this.hasBothForms) {
  //       this.snackbar = true;
  //       this.snackbarText = 'Beide Formulare (condition und function) müssen vorhanden sein, um eine Prüflisten-Instanz zu erstellen.';
  //       return;
  //     }

  //     try {
  //       this.loading = true;

  //       // Sammle alle MaintenanceListElementEntries aus beiden Formularen
  //       const allEntries: any[] = [];
  //       this.filteredForms.forEach((form: any) => {
  //         if (form.filteredEntries && form.filteredEntries.length > 0) {
  //           form.filteredEntries.forEach((entry: any) => {
  //             allEntries.push({
  //               maintenanceListElement: typeof entry.maintenanceListElement === 'object'
  //                 ? entry.maintenanceListElement._id || entry.maintenanceListElement.id
  //                 : entry.maintenanceListElement,
  //               category: form.formType === 'condition' ? MaintenanceElementCategory.condition : MaintenanceElementCategory.function,
  //               status: null,
  //               comment: ''
  //             });
  //           });
  //         }
  //       });

  //       // Erstelle eine neue Maintenance-Instanz mit der Prüfliste
  //       const maintenanceData = {
  //         productionNr: '',
  //         flapNr: '',
  //         maintenanceDate: new Date().toISOString().split('T')[0],
  //         comment: '',
  //         maintenanceList: JSON.stringify(allEntries)
  //       };

  //       const response = await maintenanceRepository.createMaintenance(this.currentMachine.id, maintenanceData);
  //       await this.loadMaintenances();

  //       this.snackbar = true;
  //       this.snackbarText = 'Prüflisten-Instanz erfolgreich erstellt';
  //     } catch (error: any) {
  //       console.error('Fehler beim Erstellen der Prüflisten-Instanz:', error);
  //       this.snackbar = true;
  //       this.snackbarText = error?.message || 'Fehler beim Erstellen der Prüflisten-Instanz';
  //     } finally {
  //       this.loading = false;
  //     }
  //   }

  // }
}

